import { render, staticRenderFns } from "./orderTapeComponent.vue?vue&type=template&id=99204302&scoped=true"
import script from "./orderTapeComponent.vue?vue&type=script&lang=js"
export * from "./orderTapeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99204302",
  null
  
)

export default component.exports